import { DropdownArrow } from '@hendrx/icons/DropdownArrow';
import { Editor } from '@tiptap/react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { LineHeightPicker } from 'shared/components/pickers/LineHeightPicker';

import { useTextStyles } from '../../../../utils/tiptap/useTextStyles';
import classes from '../ToolbarSelect.module.scss';

export type LineHeightSelectProps = {
  editor: Editor | null;
};

export function LineHeightSelect(props: LineHeightSelectProps) {
  const { editor } = props;
  const { t } = useTranslation('widgets.lineHeightSelect');
  const { getTextStyles } = useTextStyles(editor);
  const [activeLineHeight, setActiveLineHeight] = useState(getTextStyles('lineHeight'));

  useEffect(() => {
    const setLineHeight = () => {
      const activeLineHeight = getTextStyles('lineHeight');
      setActiveLineHeight(`${activeLineHeight}`);
    };

    editor?.on('selectionUpdate', setLineHeight);
    editor?.on('update', setLineHeight);

    return () => {
      editor?.off('selectionUpdate', setLineHeight);
      editor?.off('update', setLineHeight);
    };
  }, [editor, getTextStyles]);

  const handleLineHeightChange = (lineHeight: number) => {
    editor?.commands.setLineHeight(String(lineHeight));
  };

  return (
    <LineHeightPicker
      title={t('title') ?? ''}
      value={Number(activeLineHeight)}
      onChange={handleLineHeightChange}
      leftSection={<DropdownArrow />}
      leftSectionWidth={58}
      inputClassNames={{
        root: classes.lineHeightSelectRoot,
        input: classes.selectInput,
        section: classes.selectIcon
      }}
    />
  );
}
